import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function Guarantee() {
  return <section aria-labelledby="guarantee-title" className="w-full bg-white px-3 py-7 sm:px-5" data-id="element-100" data-mp="1o3x3nprb6w3l">
      <div className="mx-auto max-w-2xl rounded-2xl border-2 border-cta/40 bg-cream p-4 text-center sm:p-5" data-id="element-101" data-mp="22368xudz85ss">
        <span className="inline-flex items-center gap-1.5 rounded-full bg-cta/15 px-2.5 py-0.5 font-head text-[10px] uppercase tracking-wide text-cta-dark sm:text-xs" data-id="element-102" data-mp="1x3tnne2r76sb">
          <ShieldCheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-103" data-mp="19ceh193y23b9" />
          Zero Risk
        </span>
        <h2 id="guarantee-title" className="mt-1 font-head text-2xl uppercase leading-none text-ink sm:text-4xl" data-id="element-104" data-mp="14dtide4cbrox">
          7-Day Money-Back Guarantee
        </h2>
        <p className="mt-1.5 text-[13px] font-semibold leading-snug text-ink sm:text-base" data-id="element-105" data-mp="1ec98pevjmwxd">
          Open the complete system. Review the modules. Explore the visual supports, activities,
          adaptations, tools, templates, and bonuses.
        </p>
        <p className="mt-1.5 text-[13px] leading-snug text-muted" data-id="element-106" data-mp="ozrsamz5l05m">
          Try SPECIAL EDUCATION TEACHER PRO™ for seven full days. If you are not completely
          satisfied, contact us within the guarantee period and request a full refund.
        </p>
        <p className="mt-2 font-head text-[11px] uppercase tracking-widest text-cta-dark" data-id="element-107" data-mp="yq4gqqa39dh1">
          Your Purchase Is Protected
        </p>
      </div>
    </section>;
}